import { useCallback } from 'react';

import { useReduxDispatch } from '@/packages/redux-state/store';
import { complaintsActions } from '@/packages/redux-state/store/slices/complaints';

import { useCardOfferContext } from '../../context/selectors';

import { useCAForCard } from './useCAForCard';

export function useComplaintToOfferAction(): VoidFunction {
  const { id } = useCardOfferContext();
  const caForCard = useCAForCard();
  const dispatch = useReduxDispatch();
  const complainToOffer = useCallback(() => dispatch(complaintsActions.complaitToOffer(id)), [dispatch, id]);

  return useCallback(() => {
    caForCard({ action: 'click', category: 'complain' }, { label: true });
    complainToOffer();
  }, [caForCard, complainToOffer]);
}
